<template>
  <BaseVeeForm :action="updateFunnel" v-slot="formProps">
    <BaseCard>
      <BaseCardBody>
        <div>
          <h3 class="text-lg leading-6 font-medium text-gray-900">Funnel details</h3>
          <p class="max-w-2xl text-sm text-gray-500">The funnel's name and description</p>
        </div>
        <div class="mt-6 space-y-8">
          <BaseFormTextFieldWithValidator
            v-model="formData.name"
            :validator="{
              name: 'name',
              vid: 'name',
              rules: {
                required: true,
              },
            }"
            :field="{
              label: 'Name',
              id: 'funnel_name',
            }"
            :disabled="formProps.isPending"
          />
          <BaseFormTextareaFieldWithValidator
            v-model="formData.description"
            :validator="{
              name: 'name',
              vid: 'name',
              rules: {
                required: false,
              },
            }"
            :field="{
              label: 'Description',
              id: 'funnel_description',
            }"
            :disabled="formProps.isPending"
          />
          <BaseFormCheckboxFieldWithValidator
            v-model="formData.is_featured"
            :validator="{
              name: 'featured',
              vid: 'is_featured',
              rules: {
                required: false,
              },
            }"
            :field="{
              label: 'Featured',
              id: 'funnel_is_featured',
            }"
            :disabled="formProps.isPending"
          />
          <ValidationProvider name="funnel category" slim vid="funnel_category.id">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormLabel> Funnel category </BaseFormLabel>
                <VSelect
                  v-model="formData.funnel_category"
                  :options="funnelCategoryOptions"
                  :create-option="(name) => ({ id: null, name })"
                  :reduce="optionReducer"
                  placeholder="Select funnel category"
                  label="name"
                  :disabled="formProps.isPending"
                  taggable
                  class="vue-select"
                />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
      </BaseCardBody>
      <BaseCardFooter gray>
        <BaseButton
          primary
          :disabled="formProps.isPending || formProps.invalid || formProps.isRejected"
        >
          Update funnel
        </BaseButton>
      </BaseCardFooter>
    </BaseCard>
  </BaseVeeForm>
</template>

<script>
import { funnelCategoriesClient, funnelsClient } from '@/api/clients';

export default {
  props: {
    funnel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        name: '',
        description: '',
        funnel_category: null,
        is_featured: false,
      },
      funnelCategoryOptions: [],
    };
  },
  watch: {
    'funnel.funnel_category_id': {
      handler() {
        this.loadFunnelCategoryOptions();
      },
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      try {
        await this.loadFunnelCategoryOptions();

        this.formData.name = this.funnel.name || '';
        this.formData.description = this.funnel.description || '';
        this.formData.is_featured = this.funnel.is_featured || false;

        if (this.funnel.funnel_category_id) {
          const matchedOption =
            this.funnelCategoryOptions.find(
              (option) => option.id === this.funnel.funnel_category_id
            ) || null;

          this.formData.funnel_category = { ...matchedOption } || null;
        }

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async loadFunnelCategoryOptions() {
      try {
        const response = await funnelCategoriesClient.list();

        this.funnelCategoryOptions = response.data.map(({ id, name }) => ({ id, name }));
      } catch (error) {
        //
      }
    },
    optionReducer(option) {
      return { id: option?.id || null, name: option.name };
    },
    async updateFunnel() {
      try {
        const response = await funnelsClient.update(this.funnel.id, this.formData);

        this.$emit('updated', response.data);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
